import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeKnowledgeCategoryCompaniesResponseDataSchema,
  DataResponse,
  GetBackofficeKnowledgeCategoryCompaniesSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeKnowledgeCategoryCompaniesSchema>
type Response = DataResponse<z.infer<typeof BackofficeKnowledgeCategoryCompaniesResponseDataSchema>>

export const getBackofficeKnowledgeCategoryCompaniesQuery = (query: Query, enabled: boolean) =>
  queryOptions({
    placeholderData: () => undefined,
    queryKey: ["backofficeKnowledgeCategoryCompanies", query],
    enabled,
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/knowledge/category-companies", {
        params: query,
        signal,
      })
      return data.data
    },
  })
